import axios from 'axios';

export function apiError(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    // Policy refusals (limits, ownership, plan) return {error, message}; show the explanation, not a retry prompt.
    if (typeof data?.message === 'string' && data.message) return data.message;
    const detail = data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) return detail.map(item => item.msg).join('; ');
  }
  return 'The request failed. Please try again.';
}
